import { useState } from 'react';
import { StyledVoiceoverInput } from './VoiceoverInput.styled';
import { TextInput, TextInputMultiline, GenerateVoiceButton, VoiceSelect, IconButton } from '../'; 
import { Oval as Spinner } from 'react-loader-spinner';
import { composeShortAddress, textVoiceHash, openUrl } from '../../utils';
import { theme } from '../../theme';

const INPUT_LIMIT = 333;
const ELEVENLABS_SIGN_UP_PAGE = 'https://try.elevenlabs.io/abshvm1jk7qm';
const VOICEOVER_HELP_PAGE = '/manual';//'https://docs.google.com/presentation/d/1sXMGv3oWGTlJX-efyAjHqhi03i2q_2Bo5SDgZB2AZio/edit#slide=id.g28fcfbdc708_0_70';

const LoadingSpinner = () => {
  return (<Spinner
    height={24}
    width={24}
    color="black"
    wrapperStyle={{paddingBottom: '6px'}}
    wrapperClass=""
    visible={true}
    ariaLabel='oval-loading'
    secondaryColor="#4fa94d"
    strokeWidth={6}
    strokeWidthSecondary={6}
  />);
};

const ApiKeyEdit = ({ onSetApiKey, voiceoverApiKey = '', apiKeyInProgress = false }) => {
  const [text, setText] = useState(voiceoverApiKey);

  return (
    <div className='voiceover-input-content'>
      <div className='voiceover-input-title-holder'>
        <img className='voiceover-input-logo' src='/assets/skull.svg' />
        <div className='voiceover-input-title'>API Key</div>
      </div>
      <div className='voiceover-input-api-key-section'>
        <div className='voiceover-input-api-key-hint'>
          TEXT TO SPEAK POWERED BY ELEVEN LABS - CREATE ACCOUNT AND GRAB API KEY TO ACTIVATE
        </div>
        <IconButton
          onClick={() => openUrl(ELEVENLABS_SIGN_UP_PAGE)}>
          <div className='voiceover-input-gen-button'>
            <div>Activate</div>
            <img src='/assets/arrow.svg' />
          </div>
        </IconButton>
      </div>
      <div className='voiceover-input-api-key-section'>
        <TextInput initText={voiceoverApiKey} placeholder='Paste API Key' onChange={(text) => setText(text)} />
        <IconButton
          disabled={!text}
          onClick={() => onSetApiKey(text)}
          animated={false}
          backgroundOverwrite={theme.buttonGreen}
          backgroundOverwriteHover={theme.buttonLightGreen}
          borderOverwrite='rgba(0, 0, 0, .16)'>
          <div className='voiceover-input-gen-button'>
            <div>Apply API Key</div>
            {apiKeyInProgress ? (
                <LoadingSpinner />
              ) : (<img src='/assets/generate_voice.svg' />)
            }
          </div>
        </IconButton>
      </div>
      <IconButton
        backgroundOverwrite={theme.buttonLight}
        borderOverwrite='rgba(0, 0, 0, .16)'
        borderOverwriteHover={theme.buttonDark}
        onClick={() => openUrl(VOICEOVER_HELP_PAGE)}>
        <div className='voiceover-input-gen-button'>
          <div>Help</div>
          <img src='/assets/link_black.svg' />
        </div>
      </IconButton>
    </div>
  );
};

const VoiceoverInput = ({ generationInProgress, voiceOptions = [], selectedVoiceIndex = 0, onGenerateClicked, generateDisabled = false, lastGeneratedText = '', lastGeneratedVoice = '', onVoiceSelected, onSetApiKey, voiceoverApiKey = '', apiKeyInProgress = false, editMode = false, onEditClick }) => {
  const [text, setText] = useState(lastGeneratedText);
  const selectedVoice = voiceOptions[selectedVoiceIndex] || {id: 'none', name: 'none'};
  const alreadyGenerated = textVoiceHash(lastGeneratedText, lastGeneratedVoice) === textVoiceHash(text, selectedVoice.id);
  const disabled = generateDisabled || text.length < 1 || generationInProgress || alreadyGenerated || voiceOptions.length < 1;

  return (
    <StyledVoiceoverInput>
      <div className='voiceover-input-content-wrapper'>
        {editMode ? (<ApiKeyEdit onSetApiKey={onSetApiKey} voiceoverApiKey={voiceoverApiKey} apiKeyInProgress={apiKeyInProgress} />) : (
        <div className='voiceover-input-content'>
          <div className='voiceover-input-title-holder'>
            <img className='voiceover-input-logo' src='/assets/skull.svg' />
            <div className='voiceover-input-title'>Text Input</div>
          </div>
	  <div className='voiceover-input-api-key-holder'>
	    <div className='voiceover-input-api-key-label'>API Key:</div>
	    <div className='voiceover-input-api-key'>{composeShortAddress(voiceoverApiKey)}</div>
	    <div className='voiceover-input-api-key-edit-button' onClick={onEditClick}>
	      <img src='/assets/edit.svg' />
            </div>
	  </div>
          <TextInputMultiline initText={lastGeneratedText} generated={alreadyGenerated} limit={INPUT_LIMIT} onChange={(text) => setText(text)}/>
	  <div className='voiceover-input-stats'>
	    <div className='voiceover-input-stat-dropdown'>
	      <VoiceSelect disabled={generationInProgress} options={voiceOptions} selectedIndex={selectedVoiceIndex} onOptionSelected={onVoiceSelected}/>
	    </div>
	    <div className='voiceover-input-stat-counter'>{text.length}/<span>{INPUT_LIMIT}</span></div>
	  </div>
          <IconButton
            disabled={disabled}
            onClick={() => onGenerateClicked(text)}
            animated={false}
            backgroundOverwrite={theme.buttonGreen}
            backgroundOverwriteHover={theme.buttonLightGreen}
            borderOverwrite='rgba(0, 0, 0, .16)'>
	    <div className='voiceover-input-gen-button'>
	      <div>{generationInProgress ? 'Generating' : 'Generate Voice'}</div>
              {generationInProgress ? (
                  <LoadingSpinner />
                ) : (<img src='/assets/generate_voice.svg' />)
              }
	    </div>
          </IconButton>
        </div>)}
      </div>
      <div className='voiceover-powered-by'>
        <span className='voiceover-powered-by-label'>Powered By</span>
        <span className='voiceover-elevenlabs-logo'>llElevenLabs</span>
      </div>
      <div className='voiceover-input-corner voiceover-input-corner-tl' />
      <div className='voiceover-input-corner voiceover-input-corner-tr' />
      <div className='voiceover-input-corner voiceover-input-corner-bl' />
      <div className='voiceover-input-corner voiceover-input-corner-br' />
    </StyledVoiceoverInput>
  )
};

export default VoiceoverInput;
